import type { MangoQuery } from "rxdb"
import type { Medication } from "src/types"

const defaultSelector = {}

// adds "is_deleted" selector to medication query
export function createMedicationQueryObject({
  selector,
  sort,
  limit,
}: MangoQuery<Medication>): MangoQuery<Medication> {
  return {
    selector: {
      ...(selector ?? defaultSelector),
      $or: (selector?.$or ?? []).concat([
        { is_deleted: { $eq: false } },
        { is_deleted: { $exists: false } },
      ]),
    },
    sort,
    limit,
  }
}
